import type { ColDef, ColGroupDef } from "~/components/grid/AgGrid";

type Listener = (api: object, gridId: string) => void;
type ColumnCapabilityApplier = <T extends ColDef | ColGroupDef>(columns: T[]) => T[];

const gridIds = new WeakMap<object, string>();
const columnCapabilityAppliers = new WeakMap<object, ColumnCapabilityApplier>();
const listeners = new Set<Listener>();

export const registerServerGrid = (api: object, gridId: string): void => {
	if (gridIds.get(api) === gridId) return;
	gridIds.set(api, gridId);
	for (const listener of listeners) listener(api, gridId);
};

export const getServerGridId = (api: object | null | undefined): string | undefined =>
	api ? gridIds.get(api) : undefined;

export const subscribeServerGridRegistered = (listener: Listener): (() => void) => {
	listeners.add(listener);
	return () => {
		listeners.delete(listener);
	};
};

export const setColumnCapabilityApplier = (api: object, applier: ColumnCapabilityApplier | undefined): void => {
	if (applier) columnCapabilityAppliers.set(api, applier);
	else columnCapabilityAppliers.delete(api);
};

export const getColumnCapabilityApplier = (api: object | null | undefined): ColumnCapabilityApplier | undefined =>
	api ? columnCapabilityAppliers.get(api) : undefined;
